import { Injectable } from '@angular/core';
import {ApiService} from '../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ActionsService {

    constructor(private api: ApiService) { }

    findActions(query: Object): Observable<any> {
        return this.api.get('vna/action-history', query);
    }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/services/actions.service.ts